import React from 'react';
import { 
  Box, 
  Typography, 
  FormControl, 
  FormControlLabel, 
  RadioGroup, 
  Radio, 
  Paper, 
  Switch,
  Divider
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const HorarioConfig = ({ config, onChange }) => {
  const handleFormatoChange = (event) => {
    onChange({
      ...config,
      formato24h: event.target.value === '24h'
    });
  };

  const handleSegundosChange = (event) => {
    onChange({
      ...config,
      exibirSegundos: event.target.checked
    });
  };

  // Exemplos de formatos para visualização
  const getExemploHorario = () => {
    const agora = new Date();
    const horas = agora.getHours();
    const minutos = agora.getMinutes();
    const segundos = agora.getSeconds();
    
    // Formatar os componentes de tempo
    const formatarNumero = (num) => num.toString().padStart(2, '0');
    
    // Para formato 12h
    const horasPeriodo = horas % 12 || 12;
    const periodo = horas >= 12 ? 'PM' : 'AM';
    
    if (config.formato24h) {
      return config.exibirSegundos
        ? `${formatarNumero(horas)}:${formatarNumero(minutos)}:${formatarNumero(segundos)}`
        : `${formatarNumero(horas)}:${formatarNumero(minutos)}`;
    } else {
      return config.exibirSegundos
        ? `${formatarNumero(horasPeriodo)}:${formatarNumero(minutos)}:${formatarNumero(segundos)} ${periodo}`
        : `${formatarNumero(horasPeriodo)}:${formatarNumero(minutos)} ${periodo}`;
    }
  };

  return (
    <Paper sx={{ p: 2, borderRadius: 2, flex: 1, minWidth: 250 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <AccessTimeIcon sx={{ mr: 1, color: 'primary.main' }} />
        <Typography variant="h6">
          Formato do Horário
        </Typography>
      </Box>
      
      <Divider sx={{ mb: 2 }} />
      
      <FormControl component="fieldset">
        <Typography variant="subtitle2" gutterBottom sx={{ mb: 1 }}>
          Formato da hora:
        </Typography>
        <RadioGroup
          value={config.formato24h ? '24h' : '12h'}
          onChange={handleFormatoChange}
        >
          <FormControlLabel value="24h" control={<Radio />} label="Formato 24h" />
          <FormControlLabel value="12h" control={<Radio />} label="Formato 12h (AM/PM)" />
        </RadioGroup>
      </FormControl>
      
      <Box sx={{ mt: 3 }}>
        <FormControlLabel
          control={
            <Switch
              checked={config.exibirSegundos}
              onChange={handleSegundosChange}
              color="primary"
            />
          }
          label="Exibir segundos"
        />
      </Box>

      <Box sx={{ mt: 3, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
        <Typography variant="caption" display="block" gutterBottom>
          VISUALIZAÇÃO:
        </Typography>
        <Typography variant="h5" sx={{ fontFamily: 'monospace', fontWeight: 'medium' }}>
          {getExemploHorario()}
        </Typography>
      </Box>
    </Paper>
  );
};

export default HorarioConfig; 